<div class="container">
  <mat-card class="order-title-card">
    {{ 'orderSearch.orders' | translate }} ({{ totalOrders }})
  </mat-card>
  <order-search-list></order-search-list>
</div>
